module.exports = __webpack_public_path__ + "static/media/open_editor.459009dc.svg";